import { timestampFormatter } from '@retainerclub/common';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

function TableRowColumnPayment({ subscription, billingStates }) {
  return !billingStates.includes(subscription.state) ? (
    <span className="font-medium text-gray-600">No further charges</span>
  ) : (
    <>
      {subscription.lastPaymentAt ? (
        <span className="font-medium text-rcprimary-500">
          Last Successful Charge:{' '}
          {timestampFormatter(subscription.lastPaymentAt, false)}
        </span>
      ) : (
        <span className="font-medium">No charges yet!</span>
      )}

      {subscription.lastFailedAt && (
        <p className="font-medium text-rccallouts-danger">
          We've attempted to renew {subscription.consecutiveFailures} times.
          <br />
          Last Payment Failed:{' '}
          {timestampFormatter(subscription.lastFailedAt, false)}
          <br />
          Update your card <NavLink to="/payment-methods">here</NavLink>
        </p>
      )}

      {subscription.needsCreditCard && (
        <span className="font-medium text-rccallouts-danger">
          We need a credit card to renew. Update it{' '}
          <NavLink to="/payment-methods">here</NavLink>
        </span>
      )}
    </>
  );
}

TableRowColumnPayment.propTypes = {
  subscription: PropTypes.object.isRequired,
  // States where the renewal or retry jobs can still charge the card. "No further charges" is a
  // factual claim, and it was being shown to customers in a dunning state with retries still due.
  billingStates: PropTypes.array.isRequired,
};

export default TableRowColumnPayment;
